import api from './index';
import { RALLY_SESSIONS_LIST_PER_PAGE_ITEMS } from '../../app.config.vars/stored';
const endpoints = {
    rallies: '/admin/rallies',
    sessions: 'admin/game-sessions',
};
export const getRallyResults = async ({ rallyId, params, }) => {
    return await api.get(`${endpoints.rallies}/${rallyId}/results`, {
        params: {
            page: params.page,
            limit: RALLY_SESSIONS_LIST_PER_PAGE_ITEMS,
            ...(params.startDate ? { ['start_date']: params.startDate } : {}),
            ...(params.endDate ? { ['end_date']: params.endDate } : {}),
        },
    });
};
export const getSessionResults = async (sessionId) => {
    const res = await api.get(`${endpoints.sessions}/${sessionId}/results`);
    return res.data;
};
export const deleteRallyResults = async (rallyId) => {
    return await api.delete(`${endpoints.rallies}/${rallyId}/results`);
};
export const getRallyResultsFile = async (rallyId) => {
    return await api.get(`${endpoints.rallies}/${rallyId}/results/download`);
};
